export default __webpack_public_path__ + "static/media/Thaumaturge's Leggings of Prestige.000e3bdc.jpg";